/**
 * City Consultation Service
 * Handles city official consultation requests to unified multi-city API
 */

import type { CityConsultationFormData } from '@core';

// @ts-ignore - Vite env vars
const API_BASE_URL = import.meta.env?.VITE_API_BASE_URL || 'https://api.toolboxlogic.com';

export interface CityConsultationResponse {
  success: boolean;
  error?: string;
  data?: {
    id: string;
    market_key: string;
    created_at: string;
  };
}

export async function submitCityConsultation(
  formData: CityConsultationFormData,
): Promise<CityConsultationResponse> {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/v1/louisiana/lake-charles/consultation-request`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fullName: formData.fullName,
          title: formData.title,
          department: formData.department,
          email: formData.email,
          phone: formData.phone,
          requestingCityName: formData.cityName,
          requestingState: formData.state,
          cityPopulation: formData.population,
          bestTimeToCall: formData.bestTime,
          contactMethod: formData.contactMethod,
          challenges: formData.challenges,
        }),
      },
    );

    const result = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: result.message || `Server error: ${response.status}`,
      };
    }

    return {
      success: true,
      data: result.data,
    };
  } catch (error) {
    console.error('City consultation submission error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Network error occurred',
    };
  }
}
